import { OrderStateItem } from './order-state-item';
import { OrderState } from './order-state';

export abstract class OrderStateList {
  public static undefinedItem = new OrderStateItem(OrderState.Undefined, 'Undefined', 'ffffff', 'ffffff');

  static states: OrderStateItem[] = [
    this.undefinedItem,
    new OrderStateItem(OrderState.Created, 'Created', 'gray', '000000'),
    new OrderStateItem(OrderState.Proofed, 'Proofed', 'e9fe38', '000000'),
    new OrderStateItem(OrderState.Released, 'Released', '38fe71', '000000'),
    new OrderStateItem(OrderState.InProcess, 'InProcess', 'e9fe38', '000000'),
    new OrderStateItem(OrderState.Canceled, 'Canceled', 'fe3841', '000000'),
    new OrderStateItem(OrderState.PreProcessed, 'PreProcessed', '38e9fe', '000000'),
    new OrderStateItem(OrderState.Processed, 'Processed', '38b3fe', '000000'),
    new OrderStateItem(OrderState.Finished, 'Finished', 'fe38e6', '000000'),
    new OrderStateItem(OrderState.Paused, 'Paused', 'd1fe38', '000000'),
    new OrderStateItem(OrderState.CheckedOut, 'CheckedOut', 'ffffff', '000000')
  ];

  public static getStateItem(state: OrderState | undefined): OrderStateItem {
    if (state == undefined) {
      return this.undefinedItem;
    }
    const item = this.states.find((item) => item.state == state);
    if (item == undefined) {
      return this.undefinedItem;
    }
    return item;
  }
}
